/*
import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WarningIcon from '@mui/icons-material/Warning';

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'

export const getPackageStatus = (status: string): string => {
  const initStatus = ['SWB', 'IN'];
  const successStatus = ['DL', 'HDC', 'WHU', 'HBC', 'OK', 'BDL'];
  const inTransitStatus = ['IT', 'TRN', 'OW'];
  const warningStatus = ['HDR', 'DE'];

  if (initStatus.includes(status)) {
    return 'Initialized';
  } else if (successStatus.includes(status)) {
    return 'Success';
  } else if (inTransitStatus.includes(status)) {
    return 'In Transit';
  } else if (warningStatus.includes(status)) {
    return 'Warning';
  } else {
    return 'Initialized';
  }
};


export const getChipColor = (status: string): { color: ChipColor, icon: React.ReactElement } => {
  const initStatus = ['SWB', 'IN',];
  const successStatus = ['DL', 'HDC', 'WHU', 'HBC','OK', 'BDL'];
  const inTransitStatus = ['IT', 'TRN', 'OW'];
  const warningStatus = ['HDR', 'DE']
  if (initStatus.includes(status)) {
    return {
      color: 'default',
      icon: <InfoIcon />
    }
  }
  if (successStatus.includes(status)) {
    return {
      color: 'success',
      icon: <CheckIcon />
    }
  }
  if (inTransitStatus.includes(status)) {
    return {
      color: 'info',
      icon: <LocalShippingIcon />
    }
  }
  if (warningStatus.includes(status)) {
    return {
      color: 'warning',
      icon: <WarningIcon />
    }
  }
  return {
    color: 'default',
    icon: <InfoIcon />
  }
}
 */

import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WarningIcon from '@mui/icons-material/Warning';

type ChipColor =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning';

const STATUS_MAP = {
  init: {
    statuses: ['SWB', 'IN'],
    label: 'procesando',
    color: 'default',
    icon: <InfoIcon />,
  },
  success: {
    statuses: ['DL', 'HDC', 'WHU', 'HBC', 'OK', 'BDL'],
    label: 'entregado',
    color: 'success',
    icon: <CheckIcon />,
  },
  inTransit: {
    statuses: ['IT', 'TRN', 'OW'],
    label: 'en-camino',
    color: 'info',
    icon: <LocalShippingIcon />,
  },
  warning: {
    statuses: ['HDR', 'DE'],
    label: 'hay-un-problema',
    color: 'warning',
    icon: <WarningIcon />,
  },
};

export const getPackageStatus = (status: string) => {
  const entry = Object.values(STATUS_MAP).find(({ statuses }) =>
    statuses.includes(status),
  );
  return entry ?? STATUS_MAP.init;
};

export const getChipColor = (
  status: string,
): { color: ChipColor; icon: React.ReactElement } => {
  const entry = Object.values(STATUS_MAP).find(({ statuses }) =>
    statuses.includes(status),
  );
  return entry
    ? { color: entry.color as ChipColor, icon: entry.icon }
    : { color: STATUS_MAP.init.color as ChipColor, icon: STATUS_MAP.init.icon };
};
